import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const services = [
  {
    number: '01',
    title: 'SAT Preparation',
    description:
      'Individualized preparation built on diagnostic data, structured curriculum, and weekly in-person sessions.',
  },
  {
    number: '02',
    title: 'College & Application Strategy',
    description:
      "School selection, application strategy, essay development, and financial aid navigation — calibrated to each student's profile and goals.",
  },
  {
    number: '03',
    title: 'Mentorship & Through-Year Support',
    description:
      'A senior advising team that knows the student — sustained from diagnostic through the last college decision.',
  },
];

const Programs = () => {
  return (
    <div data-testid="programs-page">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-20 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="text-sm font-medium tracking-[0.2em] uppercase text-accent mb-6">
            Programs
          </div>
          <h1 className="text-5xl md:text-6xl font-heading font-semibold tracking-tight leading-[1.05] mb-8">
            One practice. Three threads of work.
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-primary-foreground/80 max-w-2xl">
            Every student receives all three — integrated and sequenced to their grade level, academic profile, and goals.
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="py-24 md:py-32 bg-background">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl">
          <div className="space-y-16 md:space-y-20">
            {services.map((service, idx) => (
              <div
                key={service.number}
                data-testid={`service-${idx + 1}`}
                className="grid grid-cols-12 gap-6 md:gap-12 items-start border-b border-border/40 pb-16 last:border-0 last:pb-0"
              >
                <div className="col-span-12 md:col-span-3">
                  <div className="font-heading text-6xl md:text-7xl text-accent font-semibold leading-none">
                    {service.number}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-9">
                  <h2 className="text-3xl md:text-4xl font-heading font-semibold text-primary mb-5 tracking-tight">
                    {service.title}
                  </h2>
                  <p className="text-lg leading-relaxed text-muted-foreground max-w-2xl">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Philosophy */}
      <section className="py-24 bg-muted">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-primary mb-8 tracking-tight">
            Pricing and Enrollment
          </h2>
          <div className="space-y-6 text-lg leading-relaxed text-muted-foreground">
            <p>
              Engagement terms are individually structured and discussed during your initial consultation.
            </p>
            <p>
              We assess fit, goals, and readiness before extending an invitation to enroll.
            </p>
            <p className="font-medium text-foreground">
              This is a selective process designed to ensure mutual alignment.
            </p>
          </div>
          <a
            href="/contact"
            data-testid="programs-cta"
            className="inline-block mt-12 bg-accent text-accent-foreground px-10 py-4 rounded-sm font-medium tracking-wide hover:bg-accent/90 transition-all"
          >
            Request Consultation
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Programs;
